import * as React from "react";
import { FormComponentProps } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import FormTypesGroupCategoryForm from "./FormTypesGroupCategoryForm";

export interface State {}

export interface CreateFormTypesGroupCategoryFormProps
  extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreateFormTypesGroupCategoryForm extends React.Component<
  CreateFormTypesGroupCategoryFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;

    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newFormTypesGroupCategoryData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newFormTypesGroupCategoryData = values;
        }
      });
      return newFormTypesGroupCategoryData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <FormTypesGroupCategoryForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
      ></FormTypesGroupCategoryForm>
    );
  }
}

export default CreateFormTypesGroupCategoryForm;
